import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const priceHistoryData = [
  {
    date: '5/15/2025',
    event: 'Listed for sale',
    price: '$525,000',
    change: '+35%',
    source: 'MRED MLS GRID #12317511',
    changeType: 'positive',
  },
  {
    date: '2/26/2010',
    event: 'Listing removed',
    price: '$389,000',
    change: null,
    source: 'Rubloff Chicago Real Estate #07282484',
  },
  {
    date: '11/25/2009',
    event: 'Sold',
    price: '$389,000',
    change: null,
    source: 'MRED MLS GRID #07282484',
  },
  {
    date: '9/17/2009',
    event: 'Price change',
    price: '$389,000',
    change: '-2.3%',
    source: 'Rubloff Chicago Real Estate #07282484',
    changeType: 'negative',
  },
  {
    date: '8/31/2009',
    event: 'Price change',
    price: '$398,000',
    change: '-2.7%',
    source: 'Rubloff Chicago Real Estate #07282484',
    changeType: 'negative',
  },
  {
    date: '7/29/2009',
    event: 'Listed for sale',
    price: '$409,000',
    change: '+3.5%',
    source: 'Prudential Real Estate #07282484',
    changeType: 'positive',
  },
];

const PriceHistory = () => {
  return (
    <Container className="border-top pt-4">
      <Col lg={12}>
      <div className="h3 mt-4 mb-3">Listing History</div>
      </Col>
      <Row className="fw-bold border-bottom pb-2 mb-2">
        <Col xs={12} md={2}>Date</Col>
        <Col xs={12} md={7}>Event</Col>
        <Col xs={12} md={3}>Price</Col>
      </Row>

      {priceHistoryData.map((item, index) => (
        <Row key={index} className="py-2 border-bottom">
          <Col xs={12} md={2}>{item.date}</Col>
          <Col xs={12} md={7}>
            {item.event}
            <div className="text-muted small">Source: {item.source}</div>
          </Col>
          <Col xs={12} md={3}>
            {item.price}
            {item.change && (
              <span
                className={`ms-2 fw-semibold ${
                  item.changeType === 'positive' ? 'text-success' :
                  item.changeType === 'negative' ? 'text-danger' : ''
                }`}
              >
                {item.change}
              </span>
            )}
          </Col>
        </Row>
      ))}
    </Container>
  );
};

export default PriceHistory;